import React from "react";
import ReactDOM from "react-dom";

type Props = {
  closeModal: () => void;
  heading: string;
  confirmAction: () => void;
};

const ReportModal = ({ closeModal, heading, confirmAction }: Props) => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={closeModal}
      ></div>

      <div
        className="relative bg-white rounded-lg shadow-sm z-60 font-poppins"
        style={{ width: "400px", height: "168px", overflow: "hidden" }}
      >
        <div className="p-2 font-bold text-lg">Are you Sure?</div>
        <div className="text-md pl-4 p-2">
          Do you really want to <b>{heading}</b>?
        </div>
        <div className="flex justify-center pt-2 gap-10 ">
          <div
            className="font-poppins text-sm border border-gray text-gray rounded-full px-6 py-2 cursor-pointer"
            onClick={closeModal}
          >
            Close
          </div>
          <div
            className="cursor-pointer font-poppins text-sm bg-black rounded-full text-white px-6 py-2"
            onClick={confirmAction}
          >
            Confirm
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ReportModal;
